import { makeAPIRequest } from "./makeRequest";

interface configuration {
    method: string;
    url: string;
    headers: Record<string, string>;
    data?: any;
}

let config: configuration = {
    method: 'GET',
    url:"",
    headers: {}
}
export const GetScanHistory = (scanDetails: any, Id: string) => {
    config.url = process.env.REACT_APP_SERVER_URL + `VehWizAPI/GetVehicleScanHistory?vin=${scanDetails.vin}&stock=${scanDetails.stock}&dealerid=${Id}`;
    config.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }

    let res = makeAPIRequest(config);
    return res
}